import { atom, selector } from 'recoil'
import { DEFAULT_NETWORK, BLOCK_EXPLORER_URL_MAP } from '@/constants/config'

export const systemStatusState = atom({
  key: 'SystemStatus',
  default: -1
  // 0 is running, 2 means the system is under maintenance
})

export const networkState = atom({
  key: 'Network',
  default: DEFAULT_NETWORK
})

export const chainIdState = atom({
  key: 'ChainId',
  default: DEFAULT_NETWORK === 'mainnet' ? 'nearMainnet' : 'nearTestnet'
})

export const blockExplorerUrlState = selector({
  key: 'BlockExplorerUrl',
  get: ({ get }) => BLOCK_EXPLORER_URL_MAP[get(networkState)],
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const isSystemRunningValue = selector({
  key: 'IsSystemRunning',
  get: ({ get }) => get(systemStatusState) === 0,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const isSystemMaintenanceValue = selector({
  key: 'IsSystemMaintenance',
  get: ({ get }) => get(systemStatusState) === 2,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
